import { noOp } from 'common/Constants';
import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Colors, ScreenWidth } from 'web-common/src/shared/styles';

const BannerDiv = styled.div<{ backgroundColor: Colors; isFixed: boolean }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 1em;
  width: 100%;
  top: 50px;
  z-index: 1000;

  ${ifProp(
    'isFixed',
    css`
      position: fixed;
    `
  )}
`;

const InnerBannerDiv = styled.div<{ buttonOnRight: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${ifProp('buttonOnRight', '100%', 'auto')};
  text-align: ${ifProp('buttonOnRight', 'center', 'auto')};
  position: relative;

  @media not screen and (max-width: ${ScreenWidth.SMALL}) {
    padding-right: 30px;
  }
  @media (max-width: ${ScreenWidth.SMALL}) {
    align-items: baseline;
  }
`;
const Title = styled.span<{ fontColor: Colors }>`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${({ fontColor }) => fontColor};
`;

const Description = styled.span<{ fontColor: Colors }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ fontColor }) => fontColor};
`;

const closeButtonFontSize = 16;
const CloseButtonP = styled.button<{ fontColor: Colors }>`
  font-size: ${closeButtonFontSize}px;
  color: ${({ fontColor }) => fontColor};
  top: calc(50% - ${closeButtonFontSize / 2}px);
  cursor: pointer;
  background: none;
  border: none;
  padding: 0 6px;
`;

const BannerContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export interface IConsumerBannerProps {
  title?: React.ReactNode | string;
  description?: React.ReactNode | string;
  children?: React.ReactNode;
  onClose?: () => void;
  backgroundColor?: Colors;
  fontColor?: Colors;
  onClick?: () => void;
  isFixed?: boolean;
  buttonOnRight?: boolean;
  icon?: React.ReactNode;
}

export const ConsumerBanner: React.FC<IConsumerBannerProps> = ({
  title,
  description,
  children,
  onClose,
  backgroundColor,
  onClick = noOp,
  isFixed = false,
  buttonOnRight = false,
  fontColor = Colors.WHITE,
  icon,
}: IConsumerBannerProps) => (
  <BannerDiv backgroundColor={backgroundColor ?? Colors.RADISH} onClick={onClick} isFixed={isFixed}>
    <BannerContent>
      <InnerBannerDiv buttonOnRight={buttonOnRight}>
        {title && (
          <Title fontColor={fontColor}>
            {icon && icon}
            {title}
          </Title>
        )}
        {description && <Description fontColor={fontColor}>{description}</Description>}
        {children}
      </InnerBannerDiv>
      {onClose && (
        <CloseButtonP fontColor={fontColor} onClick={onClose}>
          &#x2715;
        </CloseButtonP>
      )}
    </BannerContent>
  </BannerDiv>
);
